// Aceita apenas URLs absolutas http/https. Bloqueia esquemas perigosos como
// javascript: e data:, que executam/renderizam conteudo arbitrario
// (XSS/phishing) quando abertos via window.open — o noopener,noreferrer resolve
// tabnabbing, mas nao o esquema. Usado ao salvar (nao armazenar URL perigosa) e
// ao navegar (defesa em profundidade para dados ja persistidos/forjados).
export const isSafeHttpUrl = (value) => {
  if (!value) return false

  try {
    const { protocol } = new URL(value)
    return protocol === 'http:' || protocol === 'https:'
  } catch (e) {
    return false
  }
}
